var __merlinGlobal = (typeof window !== 'undefined' ? window : globalThis);
var __merlinTrustedTypes = __merlinGlobal.MerlinTrustedTypes || (__merlinGlobal.MerlinTrustedTypes = (function() {
    function safeSetInnerHTML(element, html) {
        if (!element) return;
        if (!html) {
            element.replaceChildren();
            return;
        }

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        element.replaceChildren();
        Array.from(doc.body.childNodes).forEach(function(node) {
            element.appendChild(document.adoptNode(node));
        });
    }

    function safeInsertAdjacentHTML(element, position, html) {
        if (!element || !html) return;

        var doc = new DOMParser().parseFromString('<body>' + html + '</body>', 'text/html');
        var fragment = document.createDocumentFragment();
        Array.from(doc.body.childNodes).forEach(function(node) {
            fragment.appendChild(document.adoptNode(node));
        });

        switch (position) {
            case 'beforeend':
                element.appendChild(fragment);
                break;
            case 'afterbegin':
                element.prepend(fragment);
                break;
            case 'beforebegin':
                element.before(fragment);
                break;
            case 'afterend':
                element.after(fragment);
                break;
        }
    }

    return {
        safeSetInnerHTML: safeSetInnerHTML,
        safeInsertAdjacentHTML: safeInsertAdjacentHTML
    };
})());
var safeSetInnerHTML = __merlinTrustedTypes.safeSetInnerHTML;
var safeInsertAdjacentHTML = __merlinTrustedTypes.safeInsertAdjacentHTML;
/**
 * Explorer Timeline Module
 * Time-based filtering with histogram visualization
 */

const ExplorerTimeline = (function() {
    'use strict';
    
    // Timeline state
    let state = {
        initialized: false,
        collapsed: false,
        minTime: null,
        maxTime: null,
        rangeStart: null,
        rangeEnd: null,
        timeField: 'timestamp', // Default field to use for time
        histogramData: [],
        dragging: null, // 'left', 'right', 'range', or null
        dragStartX: 0,
        dragStartLeft: 0,
        dragStartRight: 0
    };
    
    // DOM elements
    let elements = {};
    
    // Quick filter definitions (in milliseconds)
    const QUICK_FILTERS = {
        '1D': 24 * 60 * 60 * 1000,
        '1W': 7 * 24 * 60 * 60 * 1000,
        '1M': 30 * 24 * 60 * 60 * 1000,
        '3M': 90 * 24 * 60 * 60 * 1000,
        'YTD': null, // Special handling
        '1Y': 365 * 24 * 60 * 60 * 1000,
        'All': null
    };
    
    /**
     * Initialize timeline
     */
    function init() {
        if (state.initialized) return;
        
        console.log('[Timeline] Initializing...');
        
        // Cache DOM elements
        elements.container = document.getElementById('timeline-container');
        
        // Create timeline container if it doesn't exist (standalone mode)
        if (!elements.container) {
            createTimelineContainer();
        }
        
        if (!elements.container) {
            console.log('[Timeline] Container not found, skipping init');
            return;
        }
        
        elements.collapseBtn = elements.container.querySelector('.timeline-collapse-btn');
        elements.startDate = document.getElementById('timeline-start-date');
        elements.endDate = document.getElementById('timeline-end-date');
        elements.track = elements.container.querySelector('.timeline-track');
        elements.range = elements.container.querySelector('.timeline-range');
        elements.leftHandle = elements.container.querySelector('.timeline-handle.left');
        elements.rightHandle = elements.container.querySelector('.timeline-handle.right');
        elements.histogramContainer = elements.container.querySelector('.timeline-histogram-container');
        elements.axis = elements.container.querySelector('.timeline-axis');
        elements.quickBtns = elements.container.querySelectorAll('.timeline-quick-btn');
        elements.filterCount = document.getElementById('timeline-filter-count');
        
        // Setup event listeners
        setupEventListeners();
        
        // Extract time data from nodes
        extractTimeData();
        
        state.initialized = true;
        console.log('[Timeline] Initialized');
    }
    
    /**
     * Create timeline container dynamically (for standalone mode)
     */
    function createTimelineContainer() {
        const explorer = document.querySelector('.graph-explorer');
        if (!explorer) return;
        
        elements.container = document.createElement('div');
        elements.container.id = 'timeline-container';
        elements.container.className = 'timeline-container hidden';
        elements.container.setAttribute('role', 'region');
        elements.container.setAttribute('aria-label', 'Timeline filter');
        
        safeSetInnerHTML(elements.container, `
            <div class="timeline-header">
                <button type="button" class="timeline-collapse-btn" aria-label="Collapse timeline" title="Collapse">
                    <i data-lucide="chevron-down"></i>
                </button>
                
                <div class="timeline-range-display">
                    <div class="timeline-date">
                        <span class="timeline-date-label">Start</span>
                        <span class="timeline-date-value" id="timeline-start-date">--</span>
                    </div>
                    <span class="timeline-range-separator">
                        <i data-lucide="arrow-right"></i>
                    </span>
                    <div class="timeline-date">
                        <span class="timeline-date-label">End</span>
                        <span class="timeline-date-value" id="timeline-end-date">--</span>
                    </div>
                </div>
                
                <div class="timeline-quick-filters">
                    <button type="button" class="timeline-quick-btn" data-filter="1D">1D</button>
                    <button type="button" class="timeline-quick-btn" data-filter="1W">1W</button>
                    <button type="button" class="timeline-quick-btn" data-filter="1M">1M</button>
                    <button type="button" class="timeline-quick-btn" data-filter="3M">3M</button>
                    <button type="button" class="timeline-quick-btn" data-filter="YTD">YTD</button>
                    <button type="button" class="timeline-quick-btn" data-filter="1Y">1Y</button>
                    <button type="button" class="timeline-quick-btn active" data-filter="All">All</button>
                </div>
                
                <span class="timeline-filter-count" id="timeline-filter-count">-- / -- nodes</span>
                
                <button type="button" class="timeline-close-btn" aria-label="Hide timeline" title="Hide timeline">
                    <i data-lucide="x"></i>
                </button>
            </div>
            
            <div class="timeline-slider">
                <div class="timeline-histogram-container" id="timeline-histogram-container"></div>
                <div class="timeline-track">
                    <div class="timeline-range" id="timeline-range">
                        <div class="timeline-handle left" role="slider" aria-label="Start date" tabindex="0"></div>
                        <div class="timeline-handle right" role="slider" aria-label="End date" tabindex="0"></div>
                    </div>
                </div>
            </div>
            
            <div class="timeline-axis" id="timeline-axis"></div>
        `);
        
        explorer.appendChild(elements.container);
        
        // Initialize Lucide icons
        if (typeof lucide !== 'undefined') {
            setTimeout(() => lucide.createIcons(), 10);
        }
        
        console.log('[Timeline] Created timeline container dynamically');
    }
    
    /**
     * Setup event listeners
     */
    function setupEventListeners() {
        // Collapse toggle
        if (elements.collapseBtn) {
            elements.collapseBtn.addEventListener('click', toggleCollapse);
        }
        
        // Close button
        const closeBtn = elements.container.querySelector('.timeline-close-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', hide);
        }
        
        // Handle dragging
        if (elements.leftHandle) {
            elements.leftHandle.addEventListener('mousedown', (e) => startDrag(e, 'left'));
        }
        if (elements.rightHandle) {
            elements.rightHandle.addEventListener('mousedown', (e) => startDrag(e, 'right'));
        }
        if (elements.range) {
            elements.range.addEventListener('mousedown', (e) => startDrag(e, 'range'));
        }
        
        // Track click to set position
        if (elements.track) {
            elements.track.addEventListener('click', handleTrackClick);
        }
        
        // Mouse move and up for dragging
        document.addEventListener('mousemove', handleDrag);
        document.addEventListener('mouseup', endDrag);
        
        // Quick filter buttons
        elements.quickBtns.forEach(btn => {
            btn.addEventListener('click', () => handleQuickFilter(btn.dataset.filter));
        });
    }
    
    // Retry counter for network readiness
    let networkRetryCount = 0;
    const MAX_NETWORK_RETRIES = 3;
    
    /**
     * Extract time data from network nodes
     */
    function extractTimeData() {
        if (!window.network || !window.nodes) {
            networkRetryCount++;
            if (networkRetryCount <= MAX_NETWORK_RETRIES) {
                console.log(`[Timeline] Network not ready, will retry... (${networkRetryCount}/${MAX_NETWORK_RETRIES})`);
                setTimeout(extractTimeData, 500);
            } else {
                console.warn('[Timeline] Network not ready after max retries, giving up');
            }
            return;
        }
        // Reset retry count on success
        networkRetryCount = 0;
        
        const nodeArray = nodes.get();
        const timestamps = [];
        
        // Try different time field names
        const timeFields = ['timestamp', 'created_at', 'updated_at', 'date', 'time', 'datetime'];
        let usedField = null;
        
        nodeArray.forEach(node => {
            for (const field of timeFields) {
                if (node[field]) {
                    const time = parseTime(node[field]);
                    if (time) {
                        timestamps.push(time);
                        if (!usedField) usedField = field;
                    }
                    break;
                }
            }
        });
        
        if (timestamps.length === 0) {
            console.log('[Timeline] No time data found in nodes, generating sample data');
            // Generate sample time range for demo
            const now = Date.now();
            const yearAgo = now - (365 * 24 * 60 * 60 * 1000);
            state.minTime = yearAgo;
            state.maxTime = now;
            state.rangeStart = yearAgo;
            state.rangeEnd = now;
            state.timeField = null;
            
            // Generate sample histogram
            generateSampleHistogram(nodeArray.length);
        } else {
            state.timeField = usedField;
            state.minTime = Math.min(...timestamps);
            state.maxTime = Math.max(...timestamps);
            state.rangeStart = state.minTime;
            state.rangeEnd = state.maxTime;
            
            // Build histogram from actual data
            buildHistogram(timestamps);
        }
        
        // Update UI
        updateDisplay();
        updateSlider();
        updateAxis();
    }
    
    /**
     * Parse time value to timestamp
     */
    function parseTime(value) {
        if (!value) return null;
        
        if (typeof value === 'number') {
            return value;
        }
        
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
            return date.getTime();
        }
        
        return null;
    }
    
    /**
     * Build histogram from timestamps
     */
    function buildHistogram(timestamps) {
        const bucketCount = 50;
        const timeRange = state.maxTime - state.minTime;
        const bucketSize = timeRange / bucketCount;
        
        // Initialize buckets
        const buckets = new Array(bucketCount).fill(0);
        
        // Fill buckets
        timestamps.forEach(time => {
            const bucketIndex = Math.min(
                Math.floor((time - state.minTime) / bucketSize),
                bucketCount - 1
            );
            buckets[bucketIndex]++;
        });
        
        // Find max for normalization
        const maxCount = Math.max(...buckets, 1);
        
        // Store histogram data
        state.histogramData = buckets.map(count => count / maxCount);
        
        // Render histogram
        renderHistogram();
    }
    
    /**
     * Generate sample histogram for demo
     */
    function generateSampleHistogram(nodeCount) {
        const bucketCount = 50;
        state.histogramData = [];
        
        // Generate some variation
        for (let i = 0; i < bucketCount; i++) {
            // Create some interesting patterns
            const base = 0.2 + Math.random() * 0.3;
            const spike = (i % 7 === 0) ? 0.4 : 0;
            const trend = (i / bucketCount) * 0.3;
            state.histogramData.push(Math.min(base + spike + trend, 1));
        }
        
        renderHistogram();
    }
    
    /**
     * Render histogram bars
     */
    function renderHistogram() {
        if (!elements.histogramContainer) return;
        
        safeSetInnerHTML(elements.histogramContainer, '');
        
        state.histogramData.forEach((value, index) => {
            const bar = document.createElement('div');
            bar.className = 'timeline-histogram-bar';
            bar.style.height = `${value * 100}%`;
            bar.dataset.index = index;
            elements.histogramContainer.appendChild(bar);
        });
        
        updateHistogramHighlight();
    }
    
    /**
     * Update histogram highlight based on range
     */
    function updateHistogramHighlight() {
        const bars = elements.histogramContainer?.querySelectorAll('.timeline-histogram-bar');
        if (!bars) return;
        
        const totalRange = state.maxTime - state.minTime;
        const startPercent = (state.rangeStart - state.minTime) / totalRange;
        const endPercent = (state.rangeEnd - state.minTime) / totalRange;
        
        bars.forEach((bar, index) => {
            const barStart = index / bars.length;
            const barEnd = (index + 1) / bars.length;
            
            if (barEnd >= startPercent && barStart <= endPercent) {
                bar.classList.add('in-range');
            } else {
                bar.classList.remove('in-range');
            }
        });
    }
    
    /**
     * Toggle collapsed state (minimize/expand content)
     */
    function toggleCollapse() {
        state.collapsed = !state.collapsed;
        elements.container.classList.toggle('collapsed', state.collapsed);
    }
    
    /**
     * Show the timeline
     */
    function show() {
        if (elements.container) {
            elements.container.classList.remove('hidden');
            // Update toolbar button state
            const btn = document.getElementById('btn-timeline');
            if (btn) {
                btn.classList.add('active');
                btn.setAttribute('aria-pressed', 'true');
            }
        }
    }
    
    /**
     * Hide the timeline
     */
    function hide() {
        if (elements.container) {
            elements.container.classList.add('hidden');
            // Update toolbar button state
            const btn = document.getElementById('btn-timeline');
            if (btn) {
                btn.classList.remove('active');
                btn.setAttribute('aria-pressed', 'false');
            }
        }
    }
    
    /**
     * Toggle timeline visibility
     */
    function toggle() {
        if (elements.container && elements.container.classList.contains('hidden')) {
            show();
        } else {
            hide();
        }
    }
    
    /**
     * Start dragging
     */
    function startDrag(e, type) {
        e.preventDefault();
        e.stopPropagation();
        
        state.dragging = type;
        state.dragStartX = e.clientX;
        
        const trackRect = elements.track.getBoundingClientRect();
        const rangeRect = elements.range.getBoundingClientRect();
        
        state.trackWidth = trackRect.width;
        state.trackLeft = trackRect.left;
        state.dragStartLeft = rangeRect.left - trackRect.left;
        state.dragStartRight = trackRect.right - rangeRect.right;
        
        // Add visual feedback
        if (type === 'left') {
            elements.leftHandle.classList.add('dragging');
        } else if (type === 'right') {
            elements.rightHandle.classList.add('dragging');
        } else if (type === 'range') {
            elements.range.classList.add('dragging');
        }
        
        document.body.style.cursor = 'ew-resize';
        document.body.style.userSelect = 'none';
    }
    
    /**
     * Handle drag movement
     */
    function handleDrag(e) {
        if (!state.dragging) return;
        
        const deltaX = e.clientX - state.dragStartX;
        const totalRange = state.maxTime - state.minTime;
        const pixelToTime = totalRange / state.trackWidth;
        
        if (state.dragging === 'left') {
            const newLeft = Math.max(0, Math.min(state.dragStartLeft + deltaX, state.trackWidth));
            const leftPercent = newLeft / state.trackWidth;
            state.rangeStart = state.minTime + (leftPercent * totalRange);
            
            // Don't let left go past right
            if (state.rangeStart > state.rangeEnd - (totalRange * 0.01)) {
                state.rangeStart = state.rangeEnd - (totalRange * 0.01);
            }
        } else if (state.dragging === 'right') {
            const newRight = Math.max(0, Math.min(state.dragStartRight - deltaX, state.trackWidth));
            const rightPercent = 1 - (newRight / state.trackWidth);
            state.rangeEnd = state.minTime + (rightPercent * totalRange);
            
            // Don't let right go past left
            if (state.rangeEnd < state.rangeStart + (totalRange * 0.01)) {
                state.rangeEnd = state.rangeStart + (totalRange * 0.01);
            }
        } else if (state.dragging === 'range') {
            const timeDelta = deltaX * pixelToTime;
            const rangeSize = state.rangeEnd - state.rangeStart;
            
            let newStart = state.minTime + ((state.dragStartLeft + deltaX) / state.trackWidth) * totalRange;
            let newEnd = newStart + rangeSize;
            
            // Clamp to bounds
            if (newStart < state.minTime) {
                newStart = state.minTime;
                newEnd = newStart + rangeSize;
            }
            if (newEnd > state.maxTime) {
                newEnd = state.maxTime;
                newStart = newEnd - rangeSize;
            }
            
            state.rangeStart = newStart;
            state.rangeEnd = newEnd;
        }
        
        updateDisplay();
        updateSlider();
        updateHistogramHighlight();
    }
    
    /**
     * End dragging
     */
    function endDrag() {
        if (!state.dragging) return;
        
        // Remove visual feedback
        elements.leftHandle?.classList.remove('dragging');
        elements.rightHandle?.classList.remove('dragging');
        elements.range?.classList.remove('dragging');
        
        state.dragging = null;
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        
        // Apply filter
        applyTimeFilter();
    }
    
    /**
     * Handle click on track to jump to position
     */
    function handleTrackClick(e) {
        if (state.dragging) return;
        
        const rect = elements.track.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const percent = clickX / rect.width;
        
        const totalRange = state.maxTime - state.minTime;
        const clickTime = state.minTime + (percent * totalRange);
        
        // Move range center to click position
        const rangeSize = state.rangeEnd - state.rangeStart;
        let newStart = clickTime - (rangeSize / 2);
        let newEnd = clickTime + (rangeSize / 2);
        
        // Clamp to bounds
        if (newStart < state.minTime) {
            newStart = state.minTime;
            newEnd = newStart + rangeSize;
        }
        if (newEnd > state.maxTime) {
            newEnd = state.maxTime;
            newStart = newEnd - rangeSize;
        }
        
        state.rangeStart = newStart;
        state.rangeEnd = newEnd;
        
        updateDisplay();
        updateSlider();
        updateHistogramHighlight();
        applyTimeFilter();
    }
    
    /**
     * Handle quick filter button
     */
    function handleQuickFilter(filter) {
        // Update button states
        elements.quickBtns.forEach(btn => {
            btn.classList.toggle('active', btn.dataset.filter === filter);
        });
        
        const now = state.maxTime;
        
        if (filter === 'All') {
            state.rangeStart = state.minTime;
            state.rangeEnd = state.maxTime;
        } else if (filter === 'YTD') {
            const yearStart = new Date(new Date(now).getFullYear(), 0, 1).getTime();
            state.rangeStart = Math.max(yearStart, state.minTime);
            state.rangeEnd = state.maxTime;
        } else {
            const duration = QUICK_FILTERS[filter];
            if (duration) {
                state.rangeStart = Math.max(now - duration, state.minTime);
                state.rangeEnd = state.maxTime;
            }
        }
        
        updateDisplay();
        updateSlider();
        updateHistogramHighlight();
        applyTimeFilter();
    }
    
    /**
     * Update date display
     */
    function updateDisplay() {
        if (elements.startDate) {
            elements.startDate.textContent = formatDate(state.rangeStart);
        }
        if (elements.endDate) {
            elements.endDate.textContent = formatDate(state.rangeEnd);
        }
    }
    
    /**
     * Format timestamp as date string
     */
    function formatDate(timestamp) {
        if (!timestamp) return '--';
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }
    
    /**
     * Update slider position
     */
    function updateSlider() {
        if (!elements.range || !elements.leftHandle || !elements.rightHandle) return;
        
        const totalRange = state.maxTime - state.minTime;
        if (totalRange <= 0) return;
        
        const leftPercent = ((state.rangeStart - state.minTime) / totalRange) * 100;
        const rightPercent = ((state.maxTime - state.rangeEnd) / totalRange) * 100;
        
        elements.range.style.left = `${leftPercent}%`;
        elements.range.style.right = `${rightPercent}%`;
    }
    
    /**
     * Update axis ticks
     */
    function updateAxis() {
        if (!elements.axis) return;
        
        safeSetInnerHTML(elements.axis, '');
        
        const tickCount = 7;
        const totalRange = state.maxTime - state.minTime;
        
        for (let i = 0; i < tickCount; i++) {
            const tick = document.createElement('div');
            tick.className = 'timeline-tick';
            
            const time = state.minTime + (totalRange * (i / (tickCount - 1)));
            tick.textContent = formatAxisDate(time);
            
            elements.axis.appendChild(tick);
        }
    }
    
    /**
     * Format date for axis (shorter format)
     */
    function formatAxisDate(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            year: '2-digit'
        });
    }
    
    /**
     * Apply time filter to network
     */
    function applyTimeFilter() {
        if (!window.network || !window.nodes || !state.timeField) {
            updateFilterCount(0, 0);
            return;
        }
        
        const nodeArray = nodes.get();
        let visibleCount = 0;
        let totalCount = nodeArray.length;
        
        const updates = [];
        
        nodeArray.forEach(node => {
            const time = parseTime(node[state.timeField]);
            const inRange = !time || (time >= state.rangeStart && time <= state.rangeEnd);
            
            if (inRange) visibleCount++;
            
            // Only update if visibility changed
            if (node.hidden !== !inRange) {
                updates.push({
                    id: node.id,
                    hidden: !inRange
                });
            }
        });
        
        if (updates.length > 0) {
            nodes.update(updates);
        }
        
        updateFilterCount(visibleCount, totalCount);
        
        console.log(`[Timeline] Filter applied: ${visibleCount}/${totalCount} nodes visible`);
    }
    
    /**
     * Update filter count display
     */
    function updateFilterCount(visible, total) {
        if (elements.filterCount) {
            elements.filterCount.textContent = `${visible} / ${total} nodes`;
        }
    }
    
    /**
     * Set time range programmatically
     */
    function setRange(start, end) {
        state.rangeStart = Math.max(start, state.minTime);
        state.rangeEnd = Math.min(end, state.maxTime);
        
        updateDisplay();
        updateSlider();
        updateHistogramHighlight();
        applyTimeFilter();
    }
    
    /**
     * Get current range
     */
    function getRange() {
        return {
            start: state.rangeStart,
            end: state.rangeEnd
        };
    }
    
    /**
     * Check if timeline is available
     */
    function isAvailable() {
        return state.initialized && state.minTime !== null;
    }
    
    /**
     * Refresh timeline data
     */
    function refresh() {
        extractTimeData();
    }
    
    // Public API
    return {
        init,
        setRange,
        getRange,
        isAvailable,
        refresh,
        toggle,
        show,
        hide,
        toggleCollapse
    };
})();

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(ExplorerTimeline.init, 100);
    });
} else {
    setTimeout(ExplorerTimeline.init, 100);
}
